import { alpha, useTheme } from '@mui/material';
import { ListItem } from '../../types';

type Args = {
  isActive: boolean;
  color: ListItem['color'];
};

export const useStyles = (args: Args) => {
  const { isActive, color } = args;
  const theme = useTheme();

  return {
    listItem: {
      borderRadius: '16px',
      paddingY: '12px',
      paddingLeft: '12px',
      paddingRight: '24px',
      backgroundColor: isActive ? theme.palette.action.hover : undefined,
    },
    avatar: {
      bgcolor: alpha(theme.palette[color].main, 0.08),
      width: '48px',
      height: '48px',
    },
    avatarText: {
      color: theme.palette[color].main,
    },
    activeIcon: {
      width: '28px',
      height: '28px',
      marginLeft: 'auto',
      color: theme.palette[color].main,
    },
  };
};
